import {
  callApiGetDanhSachHoSoDuKien,
  callApiGetDanhSachDanhMucHoSo,
  callApiXoaHoSoDuKien,
  callApiThemMoiDanhMucHoSo,
  callApiXoaDanhMucHoSo,
  callApiGetChiTietDanhMucHoSo,
  callApiSuaDanhMucHoSo,
  CallApiMaHoSo,
  callApiGetDanhSachCanBoTrinh,
  callLanhDaoDvDuyetHoSo,
  callApiTrinhLanhDaoDonVi, 
  callTraLaiDanhMucHoSo,
  callApiGetListYearFilterHoSo,
  callApiGetDataLoaiHoSo,
  callApiGetDataNhomHoSo,
  callApiThemHoSoDuKien,
  callApiSuaHoSoDuKien,
  callApiGetChiTietHoSoDuKien,
  callApiXoaMultiHoSoDuKien,
  callApiGetCanBoNhanHoSoDuKien,
  callApiGuiDanhSachHoSoDuKien,
  callApiGetDanhSachDeMuc,
  callApiGetDanhSachDonViNopHoSoByYear,
  callApiGetAllDonVi,
  callApiThemMoiDonViNopHoSo,
  callApiXoaDonViNopHoSo,
  callApiXoaNhieuDonViNopHoSo,
  callApiGetDanhSachHoSoDuKienCuaDonVi,
  callApiGetDataChiTietDanhMucHoSo,
  callApiGetDanhSachHoSo,
  callApiGetDanhSachDeYKien,
  callApiThemMoiDanhMucYKien,
  callApiXoaDanhMucYKien,
  callApiGetDanhSachLichSu,
  callApiSuaYKienDanhMuc,
  callApiAddHoSo,
  callApiGetDanhSachNguoiLapHoSo,
} from "@/api/ho-so-luu-tru";

const GetAllDonVi = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiGetAllDonVi(payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const AddHoSo = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiAddHoSo(payload)
      .then((response) => {
        if (response) {
          context.commit("THEM_HO_SO", response.data);
        }
        resolve(response);
      })
      .catch((error) => {
        context.commit("THEM_HO_SO", []);
        reject(error);
      });
  });
};

const ThemMoiDonViNopHoSo = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiThemMoiDonViNopHoSo(payload)
      .then((response) => {
        if (response) {
          context.commit("THEM_HO_SO_DU_KIEN", response.data);
        }
        resolve(response);
      })
      .catch((error) => {
        context.commit("THEM_HO_SO_DU_KIEN", []);
        reject(error);
      });
  });
};

const GetDanhSachDonViNopHoSoByYear = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiGetDanhSachDonViNopHoSoByYear(payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const XoaDanhSachDonViNopHoSo = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiXoaDonViNopHoSo(payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const XoaNhieuDonViNopHoSo = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiXoaNhieuDonViNopHoSo(payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const getListYearFilterHoSo = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiGetListYearFilterHoSo(payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const GetMaHoSo = (context, payload) => {
  return new Promise((resolve, reject) => {
    CallApiMaHoSo(payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const layDanhSachHoSoDuKien = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiGetDanhSachHoSoDuKien(payload)
      .then((response) => {
        if (response) {
          context.commit("DANH_SACH_HO_SO_DU_KIEN", response.data);
        }
        resolve(response);
      })
      .catch((error) => {
        context.commit("DANH_SACH_HO_SO_DU_KIEN", []);
        reject(error);
      });
  });
};
const layDanhSachHoSo = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiGetDanhSachHoSo(payload)
      .then((response) => {
        if (response) {
          context.commit("DANH_SACH_HO_SO", response.data);
        }
        resolve(response);
      })
      .catch((error) => {
        context.commit("DANH_SACH_HO_SO", []);
        reject(error);
      });
  });
};
const layDanhSachHoSoDangThucHien = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiGetDanhSachHoSo(payload)
      .then((response) => {
        if (response) {
          context.commit("DANH_SACH_HO_SO_DANH_THUC_HIEN", response.data);
        }
        resolve(response);
      })
      .catch((error) => {
        context.commit("DANH_SACH_HO_SO_DANH_THUC_HIEN", []);
        reject(error);
      });
  });
};
const themHoSoDuKien = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiThemMoiHoSoDuKien(payload)
      .then((response) => {
        if (response) {
          context.commit("THEM_HO_SO_DU_KIEN", response.data);
        }
        resolve(response);
      })
      .catch((error) => {
        context.commit("THEM_HO_SO_DU_KIEN", []);
        reject(error);
      });
  });
};
const xoaHoSoDuKien = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiXoaHoSoDuKien(payload)
      .then((response) => {
        if (response) {
          context.commit("XOA_DANH_SACH_HS_DU_KIEN", response.data);
        }
        resolve(response);
      })
      .catch((error) => {
        context.commit("XOA_DANH_SACH_HS_DU_KIEN", []);
        reject(error);
      });
  });
};

const layDanhSachDanhMucHoSo = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiGetDanhSachDanhMucHoSo(payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const themMoiDanhMucHoSo = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiThemMoiDanhMucHoSo(payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const suaDanhMucHoSo = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiSuaDanhMucHoSo(payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const getChiTietDanhMucHoSo = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiGetDataChiTietDanhMucHoSo(payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const xoaDanhMucHoSo = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiXoaDanhMucHoSo(payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const getDanhSachCanBo = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiGetDanhSachCanBoTrinh(payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const LanhDaoDvDuyetHoSo = (context, payload) => {
  return new Promise((resolve, reject) => {
    callLanhDaoDvDuyetHoSo(payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const VanThuTrinhLanhDao = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiTrinhLanhDaoDonVi(payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const TraLaiDanhMucHoSo = (context, payload) => {
  return new Promise((resolve, reject) => {
    callTraLaiDanhMucHoSo(payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const getDataLoaiHoSo = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiGetDataLoaiHoSo(payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
const getDataNhomHoSo = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiGetDataNhomHoSo(payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const createHoSoDuKien = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiThemHoSoDuKien(payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const editHoSoDuKien = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiSuaHoSoDuKien(payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const getChiTietHoSoDuKien = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiGetChiTietHoSoDuKien(payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const xoaMultiHoSoDuKien = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiXoaMultiHoSoDuKien(payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const getCanBoNhanHoSoDuKien = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiGetCanBoNhanHoSoDuKien(payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const guiDanhSachHoSoDuKien = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiGuiDanhSachHoSoDuKien(payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const getDanhSachDeMuc = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiGetDanhSachDeMuc(payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const layDanhSachCotHoSo = (context, payload) => {
  context.commit("SET_DANH_SACH_COT_HO_SO", payload);
};

const capNhatDanhSachCotHoSo = (context, payload) => {
  context.commit("CAP_NHAT_DANH_SACH_COT_HO_SO", payload);
};

const getDanhSachHoSoDuKienCuaDonVi = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiGetDanhSachHoSoDuKienCuaDonVi(payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

// Xem chi tiết danh mục hồ sơ
const getDanhSachChiTietDanhMucHoSo = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiGetDataChiTietDanhMucHoSo(payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const getDanhSachYKien = (context,payload) =>{
  return new Promise((resolve, reject)=>{
    callApiGetDanhSachDeYKien(payload)
    .then((response)=>{
      resolve(response.data)
      context.commit('DANH_SACH_Y_KIEN', response.data) // Lưu data vào state
    })
    .catch((error)=>{
      reject(error)
    });
  });
}

const themMoiDanhMucYKien = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiThemMoiDanhMucYKien(payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const xoaDanhMucYKien = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiXoaDanhMucYKien(payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const getDanhSachLichSu = (context,payload) =>{
  return new Promise((resolve, reject)=>{
    callApiGetDanhSachLichSu(payload)
    .then((response)=>{
      resolve(response.data)
      context.commit('DANH_SACH_LICH_SU', response.data) // Lưu data vào state
    })
    .catch((error)=>{
      reject(error)
    });
  });
}

const SuaYKienDanhMuc = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiSuaYKienDanhMuc(payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};



const getDanhSachNguoiLapHoSo = (context,payload) =>{
  return new Promise((resolve, reject)=>{
    callApiGetDanhSachNguoiLapHoSo(payload)
    .then((response)=>{
      resolve(response.data)
      context.commit('DANH_SACH_NGUOI_LAP_HO_SO', response.data) // Lưu data vào state
    })
    .catch((error)=>{
      reject(error)
    });
  });
}

export default {
  TraLaiDanhMucHoSo,
  LanhDaoDvDuyetHoSo,
  VanThuTrinhLanhDao,
  getDanhSachCanBo,
  AddHoSo,
  GetAllDonVi,
  ThemMoiDonViNopHoSo,
  XoaDanhSachDonViNopHoSo,
  XoaNhieuDonViNopHoSo,
  GetDanhSachDonViNopHoSoByYear,
  layDanhSachHoSoDuKien,
  layDanhSachDanhMucHoSo,
  themMoiDanhMucHoSo,
  themHoSoDuKien,
  xoaHoSoDuKien,
  xoaDanhMucHoSo,
  getChiTietDanhMucHoSo,
  suaDanhMucHoSo,
  getListYearFilterHoSo,
  getDataLoaiHoSo,
  getDataNhomHoSo,
  createHoSoDuKien,
  editHoSoDuKien,
  layDanhSachHoSo,
  layDanhSachHoSoDangThucHien,
  getChiTietHoSoDuKien,
  xoaMultiHoSoDuKien,
  getCanBoNhanHoSoDuKien,
  guiDanhSachHoSoDuKien,
  getDanhSachDeMuc,
  layDanhSachCotHoSo,
  GetMaHoSo,
  capNhatDanhSachCotHoSo,
  getDanhSachHoSoDuKienCuaDonVi,
  getDanhSachChiTietDanhMucHoSo,
  getDanhSachYKien,
  themMoiDanhMucYKien,
  xoaDanhMucYKien,
  getDanhSachLichSu,
  SuaYKienDanhMuc,
  
  getDanhSachNguoiLapHoSo,
};
